import React from 'react';

import classNames from 'classnames/bind';
import style from './IndexPromo.scss';
const ctx = classNames.bind(style);

import SocialSharing from '../SocialSharing';

const IndexPromo = props => (
  <div className={ctx('inner')}>
    <div className={ctx('social')}>
      <SocialSharing />
    </div>
    <div className={ctx('paragraph')}>{props.children}</div>
  </div>
);

export default IndexPromo;
